/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgKeyMetric = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m8.438 8 .568-5h1.988l-.543 5h3.987l.568-5h1.988l-.543 5H21l-.23 2h-4.542l-.234 2h-1.988l.21-2h-3.988l-.444 4H12l-.23 2H9.562l-.568 5H7.006l.543-5H3l.23-2h4.542l.444-4H3l.23-2z" />
        <path d="M16.5 16.277V14h2v2.277l2.004-1.145.992 1.736L19.516 18l1.98 1.132-.992 1.736-2.004-1.145V22h-2v-2.277l-2.004 1.145-.992-1.736L15.484 18l-1.98-1.132.992-1.736z" />
      </g>
    </g>
  </Icon>
);
export { SvgKeyMetric as KeyMetric };
